<template>
  <div class="stepper">
    <div class="stepper-content">
      <div class="mb-5">
        <div class="form-group">
          <div class="md-title">1. ข้อมูลปัจจุบัน</div>
        </div>

        <div class="pdl-25">
          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 form-group">
                <div class="label no-padding">
                  เพศ
                </div>
              </div>

              <div class="col-auto">
                <div>
                  <md-radio v-model="form.gender" value="M">ชาย</md-radio>
                  <md-radio v-model="form.gender" value="F">หญิง</md-radio>
                </div>
                <error-message :msg="errorMessage.gender"></error-message>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  อายุปัจจุบัน (ปี)
                </div>
              </div>

              <div class="col-12 col-sm form-group input-group-lg">
                <input
                  type="number"
                  v-model="form.currentAge"
                  class="form-control"
                  placeholder="โปรดระบุ"
                />
                <error-message :msg="errorMessage.currentAge"></error-message>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  อายุที่ต้องการเกษียณ (ปี)
                </div>
              </div>

              <div class="col-12 col-sm form-group input-group-lg">
                <input
                  type="number"
                  v-model="form.retiredAge"
                  class="form-control"
                  placeholder="โปรดระบุ"
                />
                <error-message :msg="errorMessage.retiredAge"></error-message>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <div class="form-group">
          <div class="md-title">
            2. ข้อมูลการเงินที่คาดว่าจะใช้ยามเกษียณ (ต่อเดือน)
          </div>
        </div>

        <div class="pdl-25">
          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ค่าอาหาร (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingMonthFood"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ค่าสาธารณูปโภค (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingMonthUtility"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ค่าของใช้ส่วนตัว (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingMonthPersonal"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  เพื่อความบันเทิง (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingMonthEntertainment"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  สำหรับท่องเที่ยว (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingMonthVacation"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ค่ารักษาพยาบาล (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingMonthMedical"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center txt-primary">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  รวม (บาท)
                </div>
              </div>

              <div class="col form-group">
                {{
                  (form.spendingMonthFood +
                    form.spendingMonthUtility +
                    form.spendingMonthPersonal +
                    form.spendingMonthEntertainment +
                    form.spendingMonthVacation +
                    form.spendingMonthMedical)
                    | setNumberFormat
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <div class="form-group">
          <div class="md-title">
            3. แผนการใช้จ่าย ณ วันเกษียณ (จำนวนเงินก้อนที่คาดว่าจะใช้หลังเกษียณ)
          </div>
        </div>

        <div class="pdl-25">
          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ชำระหนี้ (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingBigDebt"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ซืื้อรถ/บ้าน (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingBigCar"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ให้ลูกหลาน (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingBigEtc"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ท่องเที่ยว (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingBigTourist"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  ค่ารักษาพยาบาล (บาท)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.spendingBigNurse"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <div class="form-group">
          <div class="md-title">4. รายรับ</div>
        </div>

        <div class="pdl-25">
          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  เงินเดือน (บาท/เดือน)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.salary"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>

                <error-message :msg="errorMessage.salary"></error-message>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  อัตราการขึ้นเงินเดือน (%)
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.salaryIncreasing"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>
                <error-message
                  :msg="errorMessage.salaryIncreasing"
                ></error-message>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  เงินออม (บาท/เดือน)

                  <div>
                    <div class="txt-desc">
                      * ไม่รวมกองทุนสำรองเลี้ยงชีพ (PVD)
                    </div>
                  </div>
                </div>
              </div>

              <div class="col form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.savingPerMonth"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>

                <error-message
                  :msg="errorMessage.savingPerMonth"
                ></error-message>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <div class="form-group">
          <div class="md-title">5. สินทรัพย์</div>
        </div>

        <div class="pdl-25">
          <div class="mb-5">
            <div class="row align-items-center">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  เงินฝาก (บาท)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="money"
                    v-model="form.asset1"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>
                  <error-message :msg="errorMessage.asset1"></error-message>
                </div>
              </div>

              <div class="col-12 col-md  input-group-lg">
                <div class="form-group">
                  ผลตอบเเทน (%)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="percent"
                    v-model="form.retAsset1"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>
                  <error-message :msg="errorMessage.retAsset1"></error-message>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="row align-items-center">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  ตราสารหนี้และกองทุนรวมตราสารหนี้ (บาท)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="money"
                    v-model="form.asset2"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>
                  <error-message :msg="errorMessage.asset2"></error-message>
                </div>
              </div>

              <div class="col-12 col-md  input-group-lg">
                <div class="form-group">
                  ผลตอบเเทน (%)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="percent"
                    v-model="form.retAsset2"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>
                  <error-message :msg="errorMessage.retAsset2"></error-message>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="row align-items-center">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  หุ้นและกองทุนรวมไทย (บาท)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="money"
                    v-model="form.asset3"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.asset3"></error-message>
                </div>
              </div>

              <div class="col-12 col-md  input-group-lg">
                <div class="form-group">
                  ผลตอบเเทน (%)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="percent"
                    v-model="form.retAsset3"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.retAsset3"></error-message>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="row align-items-center">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  กองทุนผสม (บาท)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="money"
                    v-model="form.asset4"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.asset4"></error-message>
                </div>
              </div>

              <div class="col-12 col-md  input-group-lg">
                <div class="form-group">
                  ผลตอบเเทน (%)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="percent"
                    v-model="form.retAsset4"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.retAsset4"></error-message>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="row align-items-center">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  กองทุนอสังหาริมทรัพย์ / กอง REIT และกองทุนโครงสร้างพื้นฐาน
                  (บาท)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="money"
                    v-model="form.asset6"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.asset6"></error-message>
                </div>
              </div>

              <div class="col-12 col-md  input-group-lg">
                <div class="form-group">
                  ผลตอบเเทน (%)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="percent"
                    v-model="form.retAsset6"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.retAsset6"></error-message>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="row align-items-center">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  หุ้นและกองทุนรวมหุ้นต่างประเทศ (บาท)
                  <div class="txt-desc">
                    * เงินที่จะได้รับทั้งหมดตลอดอายุของสัญญา
                  </div>
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="money"
                    v-model="form.asset5"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.asset5"></error-message>
                </div>
              </div>

              <div class="col-12 col-md  input-group-lg">
                <div class="form-group">
                  ผลตอบเเทน (%)
                  <div class="txt-desc">&nbsp;</div>
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="percent"
                    v-model="form.retAsset5"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.retAsset5"></error-message>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="row align-items-center">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  อื่นๆ (บาท) เช่น ทองคำ
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="money"
                    v-model="form.asset7"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.asset7"></error-message>
                </div>
              </div>

              <div class="col-12 col-md  input-group-lg">
                <div class="form-group">
                  ผลตอบเเทน (%)
                </div>

                <div class="form-group input-group-lg">
                  <money
                    v-bind="percent"
                    v-model="form.retAsset7"
                    class="form-control"
                    placeholder="โปรดระบุ"
                  ></money>

                  <error-message :msg="errorMessage.retAsset7"></error-message>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <div class="form-group">
          <div class="md-title">
            6. กองทุนสำรองเลี้ยงชีพ (PROVIDENT FUND : PVD)
          </div>
        </div>

        <div class="pdl-25">
          <label>
            แผนการลงทุนในกองทุนสำรองเลี้ยงชีพ (PVD) ที่สมาชิกเลือก
          </label>
        </div>

        <div class="pdv-plan">
          <div class="mb-3">
            <div class="row justify-content-center">
              <div class="col-12">
                <div class="pvd-plan mb-5 pl-5">
                  <div>
                    <md-radio v-model="form.planPVD" value="1"
                      >ไม่ทราบแผนการลงทุน</md-radio
                    >
                  </div>

                  <div>
                    <md-radio v-model="form.planPVD" value="2"
                      >ลงทุนตลาดเงินและตราสารหนี้ระยะสั้น 100%
                    </md-radio>
                  </div>

                  <div>
                    <md-radio v-model="form.planPVD" value="3"
                      >ลงทุนตราสารหนี้ 100%</md-radio
                    >
                  </div>

                  <div>
                    <md-radio v-model="form.planPVD" value="4"
                      >ลงทุนตราสารทุน 100%</md-radio
                    >
                  </div>

                  <div>
                    <div class="row">
                      <div class="col-12 col-sm-auto form-group">
                        <md-radio v-model="form.planPVD" value="5"
                          >ลงทุนแบบผสม</md-radio
                        >
                      </div>
                    </div>

                    <div class="padding-pvd">
                      <div class="row align-items-center">
                        <div
                          class="col-12 col-sm-auto form-group col-pvd"
                        >
                          ตลาดเงินและตราสารหนี้ระยะสั้น (%)
                        </div>

                        <div
                          class="col-12 col-sm-auto  form-group input-group-lg"
                        >
                          <money
                            v-model="form.planMoneyFund"
                            v-bind="percent"
                            class="form-control input-money"
                            placeholder="โปรดระบุ"
                            :disabled="form.planPVD !== '5'"
                          >
                          </money>

                          <error-message
                            :msg="errorMessage.planMoneyFund"
                          ></error-message>
                        </div>
                      </div>

                      <div class="row align-items-center">
                        <div
                          class="col-12 col-sm-auto  form-group col-pvd"
                        >
                          ตราสารหนี้ (%)
                        </div>

                        <div
                          class="col-12 col-sm-auto  form-group input-group-lg"
                        >
                          <money
                            v-model="form.planBondFund"
                            v-bind="percent"
                            class="form-control input-money"
                            placeholder="โปรดระบุ"
                            :disabled="form.planPVD !== '5'"
                          >
                          </money>

                          <error-message
                            :msg="errorMessage.planBondFund"
                          ></error-message>
                        </div>
                      </div>

                      <div class="row align-items-center">
                        <div
                          class="col-12 col-sm-auto  form-group col-pvd"
                        >
                          ตราสารทุน (%)
                        </div>

                        <div
                          class="col-12 col-sm-auto  form-group input-group-lg"
                        >
                          <money
                            v-model="form.planEquityFund"
                            v-bind="percent"
                            class="form-control input-money"
                            placeholder="โปรดระบุ"
                            :disabled="form.planPVD !== '5'"
                          >
                          </money>
                          <error-message
                            :msg="errorMessage.planEquityFund"
                          ></error-message>
                        </div>
                      </div>
                      <error-message
                        :msg="errorMessage.totalFund"
                      ></error-message>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pdl-25">
          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  เงินกองทุนสำรองเลี้ยงชีพ (PVD) ทั้งหมดในปัจจุบันของสมาชิก
                  (บาท)
                  <div class="txt-desc">
                    * รวมเงินที่สมาชิกสะสมและนายจ้างสมทบ
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.pvdAmount"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>

                <error-message :msg="errorMessage.pvdAmount"></error-message>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  อัตราร้อยละที่สมาชิกสะสม (%)
                </div>
              </div>

              <div class="col-12 col-sm form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.employee"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>

                <error-message :msg="errorMessage.employee"></error-message>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="row align-items-center">
              <div class="col-12 col-md-auto form-group">
                <div class="label no-padding">
                  อัตราร้อยละที่นายจ้างสมทบ (%)
                </div>
              </div>

              <div class="col-12 col-sm form-group input-group-lg">
                <money
                  v-bind="money"
                  v-model="form.employer"
                  class="form-control"
                  placeholder="โปรดระบุ"
                ></money>

                <error-message :msg="errorMessage.employer"></error-message>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <div class="form-group">
          <div class="md-title">
            7. กองทุนประกันสังคม (SOCIAL SECURITY FUND)
          </div>
        </div>

        <div class="pdl-25">
          <div class="row">
            <div class="col-12 col-sm-auto form-group ">
              <md-radio v-model="form.haveSSO" value="Y">มี</md-radio>
            </div>
            <div class="col-12 col-sm-auto form-group input-group-lg">
              <input
                class="form-control input-money"
                type="number"
                placeholder="ระบุจำนวนปีที่เป็นสมาชิก"
                :disabled="form.haveSSO !== 'Y'"
                v-model="form.startSSO"
              />
              <error-message :msg="errorMessage.startSSO"></error-message>
            </div>
          </div>

          <div>
            <md-radio v-model="form.haveSSO" value="N">ไม่มี</md-radio>
          </div>

          <div class="text-center">
            <div class="button-yellow" @click="nextStep(4, 'next')">ถัดไป</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ErrorMessage from "../components/errorMessage";
import * as validate from "validate.js";
import {
  SET_ADVANCE_STEPPER_DATA,
  SET_ADVANCE_ACTIVE,
} from "../store/actions.type";
import store from "../store";
import { authService } from "../services/auth";
import { retirementService } from "../services/retirement";
import { scroller } from "vue-scrollto/src/scrollTo";

export default {
  name: "AdvanceForm",
  components: { ErrorMessage },
  computed: mapState({
    form: (state) => state.advance.data.form,
    result: (state) => state.advance.data,
  }),
  data: () => ({
    errorMessage: {},
    money: {
      thousands: ",",
      precision: 0,
      masked: false,
    },
    percent: {
      precision: 2,
      masked: false,
    },
  }),
  methods: {
    async nextStep() {
      let errorMessage = this.validateForm(this.form);
      if (errorMessage) {
        return (this.errorMessage = errorMessage);
      }

      let resultObj = {
        haveSSO: "Y",
        havePVD: "Y",
        gender: this.form.gender,
        currentAge: this.form.currentAge,
        retiredAge: this.form.retiredAge,
        startSSO: this.form.haveSSO === "Y" ? this.form.startSSO : 0,
        salary: this.form.salary,
        salaryIncreasing: this.form.salaryIncreasing,
        savingPerMonth: this.form.savingPerMonth,
        pvdAmount: this.form.pvdAmount,
        employer: this.form.employer,
        employee: this.form.employee,

        planPVD: this.form.planPVD,
        planMoneyFund: this.form.planMoneyFund,
        planBondFund: this.form.planBondFund,
        planEquityFund: this.form.planEquityFund,

        spendingPerMonth:
          parseFloat(
            this.form.spendingMonthFood ? this.form.spendingMonthFood : 0
          ) +
          parseFloat(
            this.form.spendingMonthUtility ? this.form.spendingMonthUtility : 0
          ) +
          parseFloat(
            this.form.spendingMonthPersonal
              ? this.form.spendingMonthPersonal
              : 0
          ) +
          parseFloat(
            this.form.spendingMonthEntertainment
              ? this.form.spendingMonthEntertainment
              : 0
          ) +
          parseFloat(
            this.form.spendingMonthVacation
              ? this.form.spendingMonthVacation
              : 0
          ) +
          parseFloat(
            this.form.spendingMonthMedical ? this.form.spendingMonthMedical : 0
          ),

        spendingMonthFood: parseFloat(
          this.form.spendingMonthFood ? this.form.spendingMonthFood : 0
        ),
        spendingMonthUtility: parseFloat(
          this.form.spendingMonthUtility ? this.form.spendingMonthUtility : 0
        ),
        spendingMonthPersonal: parseFloat(
          this.form.spendingMonthPersonal ? this.form.spendingMonthPersonal : 0
        ),
        spendingMonthEntertainment: parseFloat(
          this.form.spendingMonthEntertainment
            ? this.form.spendingMonthEntertainment
            : 0
        ),
        spendingMonthVacation: parseFloat(
          this.form.spendingMonthVacation ? this.form.spendingMonthVacation : 0
        ),
        spendingMonthMedical: parseFloat(
          this.form.spendingMonthMedical ? this.form.spendingMonthMedical : 0
        ),

        spendingBigTourist: this.form.spendingBigTourist,
        spendingBigCar: this.form.spendingBigCar,
        spendingBigDebt: this.form.spendingBigDebt,
        spendingBigEtc: this.form.spendingBigEtc,
        spendingBigNurse: this.form.spendingBigNurse,

        asset1: this.form.asset1,
        asset2: this.form.asset2,
        asset3: this.form.asset3,
        asset4: this.form.asset4,
        asset5: this.form.asset5,
        asset6: this.form.asset6,
        asset7: this.form.asset7,
        retAsset1: this.form.retAsset1,
        retAsset2: this.form.retAsset2,
        retAsset3: this.form.retAsset3,
        retAsset4: this.form.retAsset4,
        retAsset5: this.form.retAsset5,
        retAsset6: this.form.retAsset6,
        retAsset7: this.form.retAsset7,

        inflation: 2.5,
        dilute: 80,
        discountRate: 2,
      };

      store.dispatch(SET_ADVANCE_STEPPER_DATA, {
        key: "params",
        data: resultObj,
      });

      //register if not found pram uid
      if (!this.$route.query.uid) {
        await authService.getToken().then((result) => {
          localStorage.setItem("token", result.token);
        });
      }

      let calculatePromise = retirementService.recordAdvance(resultObj);
      let suggestionPromise = retirementService.getSuggestion(resultObj);

      let [calculation, suggestion] = await Promise.all([
        calculatePromise,
        suggestionPromise,
      ]);

      store.dispatch(SET_ADVANCE_STEPPER_DATA, {
        key: "result",
        data: calculation,
      });
      store.dispatch(SET_ADVANCE_STEPPER_DATA, {
        key: "suggestion",
        data: suggestion.data ? suggestion.data : [],
      });
      store.dispatch(SET_ADVANCE_ACTIVE, 2);

      this.errorMessage = {};

      const ScrollTo = scroller();
      ScrollTo(".md-card-header");
    },

    validateForm(data) {
      let validateRule = {
        gender: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: เพศ",
          },
        },
        currentAge: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: อายุปัจจุบัน",
          },
          numericality: {
            greaterThan: 0,
            lessThan: parseFloat(data.retiredAge),
          },
        },
        retiredAge: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: อายุที่ต้องการเกษียณ",
          },
          numericality: {
            greaterThanOrEqualTo: 50,
            lessThanOrEqualTo: 70,
          },
        },

        salary: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: เงินเดือน",
          },
          numericality: {
            greaterThan: 0,
            message: "^กรุณากรอกจำนวนเงินเดือน",
          },
        },
        salaryIncreasing: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: อัตราการขึ้นเงินเดือน",
          },
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 10,
            message: "^กรุณากรอกจำนวนอัตราการขึ้นเงินเดือน 0-10%",
          },
        },
        savingPerMonth: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: เงินออม",
          },
          numericality: {
            greaterThan: 0,
            lessThanOrEqualTo: parseFloat(data.salary),
          },
        },
        planMoneyFund: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        planBondFund: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        planEquityFund: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        totalFund: {
          numericality: {
            greaterThan: 0,
            lessThanOrEqualTo: 100,
          },
        },

        pvdAmount: {
          presence: {
            allowEmpty: false,
            message:
              "^โปรดระบุ: เงินกองทุนสำรองเลี้ยงชีพ (PVD) ปัจจุบันของสมาชิก",
          },
          numericality: {
            greaterThan: 0,
            message: "^เงินกองทุนสำรองเลี้ยงชีพ (PVD) ไม่ถูกต้อง",
          },
        },
        employee: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: อัตราร้อยละที่สมาชิกสะสม",
          },
          numericality: {
            greaterThanOrEqualTo: 2,
            lessThanOrEqualTo: 15,
            message: "^กรุณากรอกตัวเลขระหว่าง 2 - 15%",
          },
        },
        employer: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: อัตราร้อยละที่นายจ้างสมทบ",
          },
          numericality: {
            greaterThanOrEqualTo: 2,
            lessThanOrEqualTo: 15,
            message: "^กรุณากรอกตัวเลขระหว่าง 2 - 15%",
          },
        },
        startSSO: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: จำนวนปีที่เป็นสมาชิก",
          },
          numericality: {
            greaterThan: 0,
            lessThan: 100,
            message: "^จำนวนปีที่เป็นสมาชิก ไม่ถูกต้อง",
          },
        },

        retAsset1: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        retAsset2: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        retAsset3: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        retAsset4: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        retAsset5: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        retAsset6: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
        retAsset7: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%",
          },
        },
      };

      if (data.haveSSO !== "Y") {
        delete validateRule.startSSO;
      }

      // set data to validate
      let errMessageList;
      if (data.planPVD === "5") {
        errMessageList = validate(
          {
            gender: data.gender,
            currentAge: data.currentAge ? parseFloat(data.currentAge) : null,
            retiredAge: data.retiredAge ? parseFloat(data.retiredAge) : null,

            salary: data.salary,
            salaryIncreasing: data.salaryIncreasing,
            savingPerMonth: data.savingPerMonth,

            retAsset1: data.retAsset1,
            retAsset2: data.retAsset2,
            retAsset3: data.retAsset3,
            retAsset4: data.retAsset4,
            retAsset5: data.retAsset5,
            retAsset6: data.retAsset6,
            retAsset7: data.retAsset7,

            planMoneyFund: data.planMoneyFund,
            planBondFund: data.planBondFund,
            planEquityFund: data.planEquityFund,
            totalFund:
              Number(data.planMoneyFund) +
              Number(data.planBondFund) +
              Number(data.planEquityFund),

            pvdAmount: data.pvdAmount,
            employee: data.employee,
            employer: data.employer,

            startSSO: data.startSSO,
          },
          validateRule
        );
      } else {
        errMessageList = validate(
          {
            gender: data.gender,
            currentAge: data.currentAge ? parseFloat(data.currentAge) : null,
            retiredAge: data.retiredAge ? parseFloat(data.retiredAge) : null,

            salary: data.salary,
            salaryIncreasing: data.salaryIncreasing,
            savingPerMonth: data.savingPerMonth,

            retAsset1: data.retAsset1,
            retAsset2: data.retAsset2,
            retAsset3: data.retAsset3,
            retAsset4: data.retAsset4,
            retAsset5: data.retAsset5,
            retAsset6: data.retAsset6,
            retAsset7: data.retAsset7,

            pvdAmount: data.pvdAmount,
            employee: data.employee,
            employer: data.employer,

            startSSO: data.startSSO,
          },
          validateRule
        );
      }

      if (errMessageList) {
        const error = {};
        for (const [key, value] of Object.entries(errMessageList)) {
          let message = value[0];

          // custom message
          if (message === "Current age must be greater than 0") {
            message = "อายุปัจจุบัน ไม่ถูกต้อง";
          } else if (
            message === "Retired age must be greater than or equal to 50" ||
            message === "Retired age must be less than or equal to 70"
          ) {
            message = "กรุณากรอกอายุที่ต้องการเกษียณในช่วง 50 - 70 ปี";
          } else if (message.includes("Current age must be less than")) {
            message = "กรุณากรอกอายุปัจจุบันน้อยกว่าอายุที่ต้องการเกษียณ";
          } else if (
            message.includes("Saving per month must be less than or equal to")
          ) {
            message = "กรุณากรอกจำนวนเงินออมน้อยกว่าเงินเดือน";
          } else if (
            message.includes("Saving per month must be greater than")
          ) {
            message = "กรุณากรอกจำนวนเงินออม";
          } else if (
            message.includes("Total fund must be less than or equal to")
          ) {
            message = "อัตราการลงทุนผสมต้องไม่เกิน 100%";
          } else if (message.includes("Total fund must be greater than")) {
            message = "อัตราการลงทุนผสมต้องมากกว่า 0%";
          }

          error[key] = message;
        }
        return error;
      } else {
        return false;
      }
    },
  },
  watch: {
    "form.planMoneyFund": {
      handler() {
        let total =
          Number(this.form.planMoneyFund) + Number(this.form.planBondFund);
        if (total < 100) {
          this.form.planEquityFund = 100 - total;
        }
      },
      deep: true,
    },

    "form.planBondFund": {
      handler() {
        let total =
          Number(this.form.planMoneyFund) + Number(this.form.planBondFund);
        if (total < 100) {
          this.form.planEquityFund = 100 - total;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/colors";

.step {
  margin-bottom: 30px;
}

.md-card {
  border-radius: 8px;
}

.md-card-header {
  border-radius: 8px 8px 0 0;
}

@media only screen and (max-width: 578px) {
  .content-body .container {
    padding: 0;
  }
}

.stepper-content,
.result {
  font-size: 22px;
}

@media only screen and (min-width: 768px) {
  .stepper-content {
    padding-right: 80px;
    padding-left: 80px;
  }

  .label {
    width: 400px !important;
  }
}

.label {
  width: 250px;
}

.md-radio {
  margin: 16px 16px 0 0;
}

.pdl-25 {
  padding-left: 25px;
}

.pdv-plan {
  padding-left: 45px;

  .md-radio {
    line-height: 1.5;
  }
}
.padding-pvd{
  padding-left: 35px;
}
.col-pvd{
  min-width: 165px;
}
.input-money{
  max-width: 250px;
}
</style>
